import './css/common.css'
import './css/app.css'
import { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom"
import axios from 'axios';
import { MessageModal } from './component/modal/modal';
import { useDispatch, useSelector } from 'react-redux';
import { setMyData } from '../store';

import useWindowSize from './hook/useWindowSize'

function Login() {
    let navigate = useNavigate();
    let dispatch = useDispatch();

    const { Rwidth, Rheight } = useWindowSize();

    const hostLogoImg = useSelector((state) => state.hostLogoImg.value);

    // 1단계: 로그인
    const [id, setId] = useState("")
    const [password, setPassword] = useState("")
    const [saveId, setSaveId] = useState(false)
    const [message, setMessage] = useState("")
    const [inputDisabled, setInputDisabled] = useState(false)

    // 2단계: PIN
    const [step, setStep] = useState("LOGIN") // "LOGIN" | "PIN"
    const [pinToken, setPinToken] = useState(null)
    const [pin, setPin] = useState("")
    const pinInputRef = useRef(null)

    const onChangeId = (e) => {
        setId(e.target.value)
    }

    const onChangePassword = (e) => {
        setPassword(e.target.value)
    }

    const onChangeSaveId = () => {
        setSaveId(e => !e)
    }

    useEffect(() => {
        let obj = localStorage.getItem('saveId')
        if (obj) {
            setId(obj)
            setSaveId(true)
        }
    }, [])

    // PIN 화면 전환 시 포커스
    useEffect(() => {
        if (step === "PIN") {
            setTimeout(() => pinInputRef.current?.focus(), 100)
        }
    }, [step])

    const resetToLogin = () => {
        setStep("LOGIN")
        setPinToken(null)
        setPin("")
    }

    // 로그인 완료 처리 (공통)
    const completeLogin = (data) => {
        if (saveId) {
            localStorage.setItem('saveId', id)
        } else {
            localStorage.removeItem('saveId')
        }
        const userData = {
            "co_nm": data?.user?.co_nm ?? "",
            "mid": data?.user?.mid ?? "",
            "sugi_expose": data?.user?.sugi_expose ?? "N",
            "kayu": data?.user?.kayu ?? 0,
            "urlpay": data?.user?.urlpay ?? 0,
            "smsKYC": data?.user?.smsKYC ?? 0,
            "smsConfirm": data?.user?.smsConfirm ?? 0,
        };
        localStorage.setItem("userId", JSON.stringify(userData));
        dispatch(setMyData(userData));
        navigate('/dashboard')
    }

    // 1단계: ID/PW 로그인
    const onSubmit = async () => {
        if (inputDisabled) return
        await axios.post(process.env.REACT_APP_API + "/api/user/login", {
            mid: id,
            password: password
        }, {
            withCredentials: true
        }).then((response) => {
            let tmp = response?.data

            if (tmp?.code === 1000) {
                if (tmp?.data?.requirePin) {
                    // PIN 입력 화면으로 전환
                    setPinToken(tmp.data.pinToken)
                    setStep("PIN")
                } else {
                    // 바로 로그인 완료
                    completeLogin(tmp.data)
                }
            }
            else if (tmp?.code === 9998) {
                // 계정 잠금
                setMessage({ msg: tmp?.error || tmp?.msg || tmp?.message || "계정이 잠금되었습니다. 관리자에게 문의하세요." })
                setInputDisabled(true)
            }
            else {
                // 4010: 비밀번호 실패 등
                setMessage({ msg: tmp?.error || tmp?.msg || tmp?.message || "로그인에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
            const data = error?.response?.data
            setMessage({ msg: data?.error || data?.msg || data?.message || "로그인에 실패했습니다." })
        });
    }

    // 2단계: PIN 검증
    const onSubmitPin = async () => {
        if (inputDisabled || !pin) return
        await axios.post(process.env.REACT_APP_API + "/api/user/verify-pin", {
            pinToken: pinToken,
            pin: pin
        }, {
            withCredentials: true
        }).then((response) => {
            let tmp = response?.data

            if (tmp?.code === 1000) {
                // 로그인 완료
                completeLogin(tmp.data)
            }
            else if (tmp?.code === 4012) {
                // 토큰 만료 → 1단계로
                setMessage({ msg: tmp?.error || tmp?.msg || tmp?.message || "인증 시간이 만료되었습니다. 다시 로그인해주세요." })
                resetToLogin()
            }
            else if (tmp?.code === 9998) {
                // 계정 잠금
                setMessage({ msg: tmp?.error || tmp?.msg || tmp?.message || "계정이 잠금되었습니다. 관리자에게 문의하세요." })
                resetToLogin()
                setInputDisabled(true)
            }
            else {
                // 4011: PIN 실패
                setMessage({ msg: tmp?.error || tmp?.msg || tmp?.message || "PIN 번호가 일치하지 않습니다." })
                setPin("")
                pinInputRef.current?.focus()
            }
        }).catch(error => {
            console.error(error);
            const data = error?.response?.data
            setMessage({ msg: data?.error || data?.msg || data?.message || "PIN 검증에 실패했습니다." })
        });
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            onSubmit()
        }
    };

    const handlePinKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            onSubmitPin()
        }
    };

    return (
        <div className="login">
            <MessageModal message={message} />
            <div className="container sm:px-10">
                <div className="block xl:grid grid-cols-2 gap-4">
                    <div className="hidden xl:flex flex-col min-h-screen">
                        <a href="" className="-intro-x flex items-center pt-5">
                            {
                                hostLogoImg == "onu"
                                    ? <img alt="Pay K Logo" src='/img/onu.png' className="w-32" />
                                    : hostLogoImg == "baekma"
                                    ? <img alt="Pay K Logo" src='/img/wh_logo_white.png' className="w-32" />
                                    : <img alt="Pay K Logo" src='/img/dl_logo_white.png' className="w-32" />
                            }
                        </a>
                        <div className="my-auto">
                            <img alt="Midone - HTML Admin Template" className="-intro-x w-1/2 -mt-16" src="/img/illustration.svg" />
                            <div className="-intro-x text-white font-medium text-4xl leading-tight mt-10">
                                {
                                    hostLogoImg == "onu"
                                        ? "onu"
                                        : hostLogoImg == "baekma"
                                        ? "백마나무"
                                        : "빠른결제대행사"
                                }  <br />
                                가맹점
                            </div>
                            {/* <div className="-intro-x mt-5 text-lg text-white text-opacity-70 dark:text-slate-400">결제 페이지</div> */}
                        </div>
                    </div>
                    <div className="h-screen xl:h-auto flex xl:py-0 xl:my-0" style={{ height: "100dvh" }}>
                        <div className="my-auto mx-auto xl:ml-20 bg-white dark:bg-darkmode-600 xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none sm:w-3/4 lg:w-2/4 xl:w-auto"
                            style={{ width: Rwidth > 767 ? "" : "90%" }}>

                            {step === "LOGIN" ? (
                                <>
                                    <h2 className="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left">
                                        가맹점 로그인
                                    </h2>
                                    <div className="intro-x mt-2 text-slate-400 xl:hidden text-center">  {
                                        hostLogoImg == "onu"
                                            ? "onu"
                                            : hostLogoImg == "baekma"
                                            ? "백마나무"
                                            : "빠른결제대행사"
                                    } - 가맹점 페이지</div>
                                    <div className="intro-x mt-8">
                                        <form onSubmit={(e) => e.preventDefault()}>
                                            <input type="text" id="login-id" className="intro-x login__input form-control py-3 px-4 block" placeholder="아이디" value={id} onChange={onChangeId} disabled={inputDisabled} />
                                            <input type="password" id="login-pw" autoComplete="off" className="intro-x login__input form-control py-3 px-4 block mt-4" placeholder="패스워드" value={password} onChange={onChangePassword} onKeyDown={handleKeyPress} disabled={inputDisabled} />
                                        </form>
                                    </div>
                                    <div className="intro-x flex text-slate-600 dark:text-slate-500 text-xs sm:text-sm mt-4">
                                        <div className="flex items-center mr-auto">
                                            <input type="checkbox" className="form-check-input border mr-2" id="saveId" checked={saveId} onChange={onChangeSaveId} />
                                            <label className="cursor-pointer select-none">아이디 저장</label>
                                        </div>
                                    </div>
                                    <div className="intro-x mt-5 xl:mt-8 text-center xl:text-left">
                                        <button id="login-btn" className="btn btn-primary py-3 px-4 w-full xl:w-32 xl:mr-3 align-top" style={{ width: "100%" }}
                                            onClick={() => onSubmit()} disabled={inputDisabled}>
                                            로그인
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <h2 className="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left">
                                        PIN 번호 입력
                                    </h2>
                                    <div className="intro-x mt-2 text-slate-400 text-center xl:text-left">
                                        PIN 번호를 입력해주세요
                                    </div>
                                    <div className="intro-x mt-8">
                                        <form onSubmit={(e) => e.preventDefault()}>
                                            <input
                                                ref={pinInputRef}
                                                type="password"
                                                id="login-pin"
                                                autoComplete="off"
                                                inputMode="numeric"
                                                maxLength={4}
                                                className="intro-x login__input form-control py-3 px-4 block"
                                                placeholder="PIN 번호 4자리"
                                                value={pin}
                                                onChange={(e) => setPin(e.target.value.replace(/[^0-9]/g, ''))}
                                                onKeyDown={handlePinKeyPress}
                                                disabled={inputDisabled}
                                                style={{ textAlign: "center", letterSpacing: "8px", fontSize: "20px" }}
                                            />
                                        </form>
                                    </div>
                                    <div className="intro-x mt-5 xl:mt-8 text-center xl:text-left" style={{ display: "flex", gap: "8px" }}>
                                        <button
                                            className="btn btn-primary py-3 px-4 align-top"
                                            style={{ flex: 1 }}
                                            onClick={() => onSubmitPin()}
                                            disabled={inputDisabled || pin.length !== 4}
                                        >
                                            확인
                                        </button>
                                        <button
                                            className="btn btn-outline-secondary py-3 px-4 align-top"
                                            style={{ flex: 1 }}
                                            onClick={() => resetToLogin()}
                                        >
                                            취소
                                        </button>
                                    </div>
                                </>
                            )}

                            <div className="intro-x mt-10 text-slate-600 dark:text-slate-500 text-center xl:text-left">
                                <a className="text-primary dark:text-slate-200" href="/terms">이용약관</a>&nbsp;&nbsp;&nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login;